import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { head } from '@/router/Head';

export const Route = createFileRoute('/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs')({
  staticData: {
    title: 'Cluster',
  },
  head,
  component: lazyRouteComponent(() => import('@/components/Clusters/ClusterLayout'), 'ClusterIdIndexComponent'),
});
